import { ChangeDetectionStrategy, Component, Input, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';

import { CaseModel } from '@app/ps/models/case.model';
import { CaseService } from '@app/ps/services/case.service';
import { StateService } from '@uirouter/angular';
import { Restangular } from 'ngx-restangular';

@Component({
  selector: 'expropriation-interim-decision',
  templateUrl: './expropriation-interim-decision.component.html',
})
export class ExpropriationInterimDecisionComponent implements OnInit {
  @Input() caseId: number;
  public loading = true;
  public data: CaseModel;
  public isValid: Function;
  public recipient: any;

  constructor(
    private caseService: CaseService,
    private stateService: StateService,
    private restangular: Restangular,
  ) {
    this.onSubmit = this.onSubmit.bind(this);
  }

  ngOnInit() {
    this.restangular.one('cases', this.caseId).get().toPromise().then((data) => {
      this.data = data;
      this.loading = false;
    });
  }

  formCallbackRegister($event) {
    this.isValid = $event.isValid;
  }

  async onSubmit(): Promise<any> {
    const sendData = {
      expropriationInterimDecisionDate: this.data.expropriationInterimDecisionDate,
      expropriationStartDeadlineDate: this.data.expropriationStartDeadlineDate,
    };
    await this.restangular
      .one('cases', this.caseId)
      .customPUT(sendData, 'expropriation-interim-decision')
      .toPromise();

    this.stateService.go('^');
  }
}

